import { WebViewerInstance } from '@pdftron/webviewer';

class DocumentHighlight {
  instance: WebViewerInstance;

  constructor(instance: WebViewerInstance) {
    this.instance = instance;
  }

  removeAnnotationDocumentHighlight() {
    const classNames = ['document-highlight', 'document-red-highlight', 'document-green-highlight'];
    const classList = this.instance.UI.iframeWindow.frameElement?.classList;

    if (classList) {
      classNames.forEach((className) => classList.remove(className));
    }
  }

  addDocumentHighlight() {
    const className = 'document-highlight';
    const { frameElement } = this.instance.UI.iframeWindow;
    frameElement?.classList?.add(className);
  }

  addRedDocumentHighlight() {
    const className = 'document-red-highlight';
    const { frameElement } = this.instance.UI.iframeWindow;
    frameElement?.classList?.add(className);
  }

  addGreenDocumentHighlight() {
    const className = 'document-green-highlight';
    const { frameElement } = this.instance.UI.iframeWindow;
    frameElement?.classList?.add(className);
  }

  removeDocumentTransition() {
    const className = 'document-transition';
    const { frameElement } = this.instance.UI.iframeWindow;
    frameElement?.classList?.remove(className);
  }

  addDocumentTransition() {
    const className = 'document-transition';
    const { frameElement } = this.instance.UI.iframeWindow;
    frameElement?.classList?.add(className);
  }
}

export default DocumentHighlight;
